module.exports = {
    'queryResourceQuota': '/api/bm/queryResourceQuota',
    'calculateTotalPrice': '/api/price/calculateTotalPrice',
    'getCustomInfo': '/api/usercenter/getCustomInfo'
};



// WEBPACK FOOTER //
// ./src/api/common/config.js